var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareIcon = function SvgShareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A9A29D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667,
    d: "m5.492 10.425 5.691 3.316m-.008-9.15L5.492 7.908m10.341-4.575a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m-10 5.833a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0m10 5.834a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0"
  })));
};
export default SvgShareIcon;